require('./style.less');

var Marionette = require('marionette'),
    AccessGroupSelector = require('../../../notes/views/note/accessGroupSelector/view'),
    ConsultGroupSelector = require('../../../notes/views/note/consultGroupSelector/view'),
    ShapePropertiesViewFactory = require('./shapeProperties/factory'),
    fvChannel = require('glRadio').channel('FV');


/**
 * No Subclass yet by type yet, it's generic enough -- may want a factory.
 *
 */

module.exports = Marionette.LayoutView.extend({

    constructor: function() {

        this.channel = null;
        this.model = null; // ( searchModel )

        this.disableInputs = false;
        this.includeZonePropertiesView = false;

        this.showConsultGroupSelection = null;

        Marionette.LayoutView.apply( this, arguments );

    },

    initialize: function( options ) {

        this.channel = options.channel;
        // ( this.model is passed in already )

        if ( options.disableInputs ) {
            this.disableInputs = true;
        }

        this.includeZonePropertiesView = this.model.shape.getHasCustomizableProperties();

        this.showConsultGroupSelection = this.model.showConsultGroupSelectorOnNoteViews(); // what is none exist in system?

    },

    template: require('./template.hbs'),

    regions: {
        consultGroupRegion:     '.fr-consult-group-selector',
        accessGroupRegion:      '.fr-access-group-selector',
        shapePropertiesRegion:  '.fr-note-level-shape-properties-region'
    },

    ui: {
        subjectInput:           '.fr-note-subject',
        autoDisplayRadioBtn:    '#fr-autoDisplay', // TODO: form id with for attr ...
        notePropertiesHeader:   '.fr-note-properties-header', // TODO: use plugin
        zonePropertiesHeader:   '.fr-note-zone-header', // TODO: use a plugin here ...

        notePropertiesSection:  '.fr-note-properties'
    },


    events: {
        'input @ui.subjectInput':           'subjectChange', // (input works IE9+)
        'change @ui.autoDisplayRadioBtn':   'autoDisplayChange',

        'click @ui.zonePropertiesHeader':   'toggleZoneProperties', // TODO: plugin
        'click @ui.notePropertiesHeader':   'toggleNoteProperties' // TODO: plugin
    },

    serializeData: function() {

        return  {

            subject: this.model.get('title'),
            maxSubjectMax: fvChannel.request('getPageNoteTitleMaxLength'), // works IE10+
            showAutoDisplay: this.model.autoDisplayApplies,
            autoDisplay: this.model.autoDisplayNote(),
            includeZonePropertiesView: this.includeZonePropertiesView,
            showConsultRow: this.showConsultGroupSelection,
            disableNotePropertyInputs: this.disableInputs,

            // TODO: no longer desired -- and if do, use plugin ...
            collapseZoneProperties: false,
            collapseNoteProperties: false

        };

    },

    onBeforeShow: function() {

        var user = fvChannel.request('user');

        /* --- Note Level --- */

        this.accessGroupRegion.show( new AccessGroupSelector({

            groups: user.groups.getArrayOfModelAttrsSortedByName(), // TODO: sort on the view layer
            onChange: _.bind( function( selectedGroup ) {

                // TODO: api should change so group name properties match -- or it takes a group model ....
                // What a disaster i was given to work with

                this.model.set({
                    accessGroup: selectedGroup.groupId,
                    accessGroupName: selectedGroup.name // TODO: do we ever use this name ???
                });


            }, this),

            selectedGroupId: this.model.get('accessGroup'),
            renderDisabled: this.disableInputs

        }));


        if ( this.showConsultGroupSelection ) {

            this.consultGroupRegion.show( new ConsultGroupSelector({

                userConsultGroups: user.getReferralGroups(),
                note: this.model,
                renderDisabled: this.disableInputs,

                /**
                 * Store selected groups on the model for saving later.
                 * Should change reviewGroups serverSide in DocViewer API ...
                 * Regular note process only saves the 'live color'; ...
                 * TODO: it should be changed to store the selected groups live instead ( if there's a larger need )
                 */
                onChange: _.bind( function( selectedGroups ) {

                    this.model.set({
                        reviewGroups: {
                            consultation: selectedGroups // ( consultation set to null if none exist )
                        }
                    });


                }, this)

            }) );
        }

        /* -- Shape Level --*/

        if ( this.includeZonePropertiesView ) {

            var ShapePropertiesView = ShapePropertiesViewFactory( this.model, 'note' );

            this.shapePropertiesRegion.show( new ShapePropertiesView({
                shape: this.model.shape,
                renderDisabled: this.disableInputs,
                channel: this.channel
            }) );

        }

    },

    /* The subject of the saved note will be that of the search, unless the user enters something */
    subjectChange: function( e ) {
        this.model.set( 'title', $(e.target).val() );
    },

    autoDisplayChange: function( e ) {
        this.model.set( 'noteStatus', $(e.target).is(':checked') ? 'V' : 'I' );
    },



    // TODO:  plugin
    toggleNoteProperties: function() {

        this.ui.notePropertiesHeader.find('i').toggleClass('icon-right-dir-1 icon-down-dir-1');
        this.ui.notePropertiesSection.toggleClass('hide');

    },

    // TODO:  plugin ... this is even too hacky
    toggleZoneProperties: function() {

        this.ui.zonePropertiesHeader.find('i').toggleClass('icon-right-dir-1 icon-down-dir-1');
        this.shapePropertiesRegion.$el.toggleClass('hide');

    }




});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/notePropertyViews/view.js
 ** module id = 598
 ** module chunks = 0
 **/